// ============================================================
// Supabase client configuration
// ============================================================
// Project URL & anon/publishable key — keduanya AMAN dipakai di
// frontend (bukan rahasia seperti service_role key). Akses ke
// data tetap dibatasi oleh Row Level Security (RLS) policy yang
// sudah didefinisikan di schema.sql.
// ============================================================
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://vmtitckvehshbelcujlk.supabase.co";
const SUPABASE_ANON_KEY = "sb_publishable_IFguV6_lqqCCTFtxliVPwA_oVw3fqFK";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
